<template>
  <div class="card card-table">
    <div class="card-header">
      <button
        type="button"
        class="btn btn-outline-primary btn-icon"
        @click="onSaved"
      >
        <i class="fas fa-check"></i>
      </button>
      <button
        type="button"
        class="btn btn-outline-danger btn-icon"
        @click="onClosed"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="card-body">
      <div class="table-responsive custom-table">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>{{ $t("columnName.delete") }}</th>
              <th>{{ $t("columnName.daybegin") }}</th>
              <th>{{ $t("columnName.dayend") }}</th>
              <th>{{ $t("columnName.sunday") }}</th>
              <th>{{ $t("columnName.monday") }}</th>
              <th>{{ $t("columnName.tuesday") }}</th>
              <th>{{ $t("columnName.wednesday") }}</th>
              <th>{{ $t("columnName.thursday") }}</th>
              <th>{{ $t("columnName.friday") }}</th>
              <th>{{ $t("columnName.saturday") }}</th>
              <th>{{ $t("columnName.timebegin") }}</th>
              <th>{{ $t("columnName.timeend") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(dayModule, index) in dayModules"
              :key="dayModule.DayModuleId"
            >
              <td>
                <button
                  class="btn btn-outline-danger btn-icon"
                  @click="onRemoved(index)"
                >
                  <i class="fas fa-trash-alt"></i>
                </button>
              </td>
              <td>
                <input
                  type="date"
                  style="width: 200px"
                  class="form-control"
                  v-model="dayModule.DayBegin"
                />
              </td>
              <td>
                <input
                  type="date"
                  style="width: 200px"
                  class="form-control"
                  v-model="dayModule.DayEnd"
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  class="checkbox"
                  v-model="dayModule.Sunday"
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  class="checkbox"
                  v-model="dayModule.Monday"
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  class="checkbox"
                  v-model="dayModule.Tuesday"
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  class="checkbox"
                  v-model="dayModule.Wednesday"
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  class="checkbox"
                  v-model="dayModule.Thursday"
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  class="checkbox"
                  v-model="dayModule.Friday"
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  class="checkbox"
                  v-model="dayModule.Saturday"
                />
              </td>
              <td>
                <div class="row" style="width: 180px">
                  <input
                    :id="index + 'HourBegin'"
                    type="number"
                    class="form-control col"
                    v-model="dayModule.HourBegin"
                  />
                  <label :for="index + 'HourBegin'" class="col-1 col-form-label"
                    >:</label
                  >
                  <input
                    type="number"
                    class="form-control col"
                    v-model="dayModule.MinuteBegin"
                  />
                </div>
              </td>
              <td style="width: 180px">
                <div class="row" style="width: 180px">
                  <input
                    :id="index + 'HourEnd'"
                    type="number"
                    class="form-control col"
                    v-model="dayModule.HourEnd"
                  />
                  <label :for="index + 'HourEnd'" class="col-1 col-form-label"
                    >:</label
                  >
                  <input
                    type="number"
                    class="form-control col"
                    v-model="dayModule.MinuteEnd"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <button class="btn btn-outline-primary btn-icon" @click="onAdd">
                  <i class="fas fa-plus"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      moduleId: "",
      dayModules: [],
    };
  },
  methods: {
    onAdd() {
      this.dayModules.push(this.$func.defaultModel.getDayModule());
    },
    onRemoved(index) {
      this.dayModules.splice(index, 1);
    },
    onSaved() {
      if (this.dayModules.length == 0) {
        this.$func.message.alert("請輸入日期 !");
        return;
      }
      const vm = this;
      this.$api.modules
        .postDays(vm.moduleId, vm.dayModules)
        .then(() => vm.onClosed());
    },
    onClosed() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.moduleId = this.$route.params["id"];
    if (!this.moduleId || this.moduleId.length == 0) this.onClosed();
    const vm = this;
    this.$api.modules
      .getDays(vm.moduleId)
      .then((data) => (vm.dayModules = data));
  },
};
</script>
